/* eslint-disable */
import React, { useState } from 'react'
import AppLoader from 'src/components/AppLoader'
import { ToastContainer, toast } from 'react-toastify'
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormFeedback,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilLockLocked } from '@coreui/icons'
import { post, postWithImage } from 'src/network/api'

const ResetPassword = () => {
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const token = new URLSearchParams(window.location.search).get('token')
  console.log('Reset token:', token)
  const handleSubmit = (event) => {
    event.preventDefault()
    const newErrors = {}

    // Basic validation
    if (!password) {
      newErrors.password = 'Password is required'
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = 'Confirm Password is required'
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match'
    }

    setErrors(newErrors)

    if (Object.keys(newErrors).length === 0) {

      // Here you would typically send the new password and token to the server
      

      // alert('Password reset successfully')
      resetPassword();
      // setPassword('')
      // setConfirmPassword('')
    }
  }

  async function resetPassword() {
        try {
           setLoading(true)
          const data = await post("restaurant/reset-password", {
            'password':password,
            'token':token
          });
           setLoading(false)
          toast.success("Password reset successfully!", {
                  position: "bottom-center",
                  autoClose: 3000,
                });
        }
  
        catch (e) {
           setLoading(false)
          console.log(e)
  toast.error(e.toString(), {
          position: "bottom-center",
          autoClose: 3000,
        });
          console.log(e)
        }
      }
  const handlePasswordChange = (e) => {
    setPassword(e.target.value)
    if (errors.password) {
      setErrors((prevErrors) => ({ ...prevErrors, password: '' }))
    }
  }

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value)
    if (errors.confirmPassword) {
      setErrors((prevErrors) => ({ ...prevErrors, confirmPassword: '' }))
    }
  }

  return (
    <div className="bg-body-tertiary min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol lg={6} xl={5} sm={12}>
            <CCardGroup>
              <CCard className="p-lg-4">
                <CCardBody>
                  <CForm onSubmit={handleSubmit}>
                    <h1 className="mb-4">Reset Password</h1>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        placeholder="Password"
                        autoComplete="new-password"
                        value={password}
                        onChange={handlePasswordChange}
                        invalid={!!errors.password}
                      />
                      {errors.password && <CFormFeedback invalid>{errors.password}</CFormFeedback>}
                    </CInputGroup>

                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        placeholder="Confirm Password"
                        autoComplete="new-password"
                        value={confirmPassword}
                        onChange={handleConfirmPasswordChange}
                        invalid={!!errors.confirmPassword}
                      />
                      {errors.confirmPassword && (
                        <CFormFeedback invalid>{errors.confirmPassword}</CFormFeedback>
                      )}
                    </CInputGroup>

                    <CRow>
                      <CCol xs={12}>
                        <CButton type="submit" color="primary" className="px-4 text-white">
                          Reset Password
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>

      {loading && <AppLoader />}
      <ToastContainer />
    </div>
  )
}

export default ResetPassword
